import AbstractType from "@/application/typeConfig/AbstractTypeConfig.ts";
import type {StepperItem} from "@/domain/type/config.type.ts";
import {RouteEnum} from "@/router/RouteEnum.ts";
import {SynchroType} from "@/domain/type/synchro.type.ts";
import {Source} from "@/domain/type/source.type.ts";

export default class LocationConfig extends AbstractType {
  getStepperItems(): StepperItem[] {
    return []
  }

  sourceLeftList(): Source[] {
    return [Source.EVA];
  }

  sourceRightList(): Source[] {
    return [Source.AMMON];
  }

  cleanFieldValue(value: string, label: string): string {
    if ('Adresse' === label) {
      let newValue = '';
      const addressData = JSON.parse(value);
      newValue += (addressData.addressee ?? '') + '\n\n'
      newValue += (addressData.line1 ?? '') + '\n\n'
      if (addressData.line2) {
        newValue += addressData.line2 + '\n'
      }
      if (addressData.line3) {
        newValue += addressData.line3 + '\n'
      }
      if (addressData.line4) {
        newValue += addressData.line4 + '\n'
      }

      newValue += (addressData.postcode ?? '') + ' ' + (addressData.city ?? '') + '\n'
      newValue += (addressData.country ?? '') + '\n\n'
      newValue += (addressData.email ?? '') + '\n'
      newValue += (addressData.phone ?? '') + '\n'
      newValue += (addressData.webSite ?? '') + '\n'
      return newValue
    }
    return value;
  }

  private getRoute(routeName: RouteEnum): any {
    switch (routeName) {
      case RouteEnum.SyncWithoutOwner:
        return {
          name: RouteEnum.SyncWithoutOwner,
          params: {
            type: SynchroType.LOCATION,
          },
          query: {
            _r: Date.now()
          }
        }
    }
  }
}
